import {PointOfContactProps} from "@/interfaces/point-of-contact_types.ts";
import {useForm} from "react-hook-form"
import {z} from "zod";
import {zodResolver} from "@hookform/resolvers/zod";
import {PointOfContactFormSchema} from "@/components/PointOfContacts/Form/Interface/DefaultSchema.ts";
import {DefaultProps} from "@/components/PointOfContacts/Form/Interface/DefaultProps.ts";
import {ImportFormProps} from "@/components/PointOfContacts/Form/Interface/ImportFormProps.ts";
import {Alert} from "@/components/_Shared/Form/Buttons/Alert.tsx";
import {useEffect} from "react";
import {Error_Component, MethodHandler} from "@/components/misc.tsx";
import {PointOfContactFormBase} from "@/components/PointOfContacts/Form/PointOfContactFormBase.tsx";
import { useFormData } from "@/components/_Shared/Form/Hooks/useFormDataFetch"
import { createPointOfContact, updatePointOfContact } from "@/api/point-of-contact";

export function PointOfContactForm({formProps, method } : { formProps?: PointOfContactProps, method: "POST" | "PUT" }) {
    const {
        register,
        handleSubmit,
        formState: { errors, isSubmitSuccessful, isSubmitting },
        control,
        setError,
    } = useForm<z.infer<typeof PointOfContactFormSchema>>({
        resolver: zodResolver(PointOfContactFormSchema),
        defaultValues: formProps ? ImportFormProps({formProps}) : DefaultProps()
    })

    const { clients, fetchAllDataProject } = useFormData()

    const onSubmit = async (data: z.infer<typeof PointOfContactFormSchema>) => {
        const method_handler = MethodHandler(method, createPointOfContact, updatePointOfContact)

        if (method_handler) {
            const response = await method_handler(data)

            if (response.operation === "ERROR") {
                setError("root", {message: "An error occurred while submitting the point of contact form."})
            }
        } else {
            console.error("Method handler not found")
            setError("root", {message: "An error occurred while submitting the point of contact form."})
        }
    }

    useEffect(() => {
        fetchAllDataProject()
    }, [fetchAllDataProject])

    return (
        <>
            {isSubmitSuccessful &&
                <Alert
                    title={"Success"}
                    description={"The Point of Contact has been saved"}
                    redirects={
                        [
                            {label: "To Point of Contact Table", value: "/point_of_contact/list"},
                            {label: "To Dashboard", value: "main_menu"}
                        ]
                } />}

            {errors.root && <Error_Component errorString={errors.root.message || "An error has occurred"}/>}

            <PointOfContactFormBase
                register={register}
                errors={errors}
                control={control}
                client_list={clients}
                onSubmit={handleSubmit(onSubmit)}
                method={method}
                isProcessing={isSubmitting}
            />
        </>
    )
}